// 常量
export const SOFTWARE_PROJECT_ID = 383;
export const SOFTWARE_PROJECT_NAME = "BIM";